import React, { useEffect, useState } from "react";
import { Menu, X, Sparkles } from "lucide-react";
import { MARLEA } from "@/constants/testIds";
import { Logo } from "./Logo";

export const Navbar = ({ onScrollDemo }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { id: MARLEA.navLinkWat, href: "#waarom", label: "Waarom?" },
    { id: "nav-link-wat-doet-het", href: "#wat-doet-het", label: "Wat doet het?" },
    { id: MARLEA.navLinkVoorWie, href: "#hoe-werkt-het", label: "Hoe werkt het?" },
    { id: "nav-link-faq", href: "#faq", label: "FAQ" },
    { id: "nav-link-demo", href: "#demo", label: "Demo aanvragen" },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        scrolled ? "py-2" : "py-3"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <nav
          className={`relative flex items-center justify-between rounded-2xl pl-3 pr-3 md:pl-4 md:pr-2.5 transition-all duration-300 ${
            scrolled ? "glass-strong" : "border border-white/5 bg-[#0A0A1A]/30 backdrop-blur-md"
          }`}
          style={{ height: scrolled ? 60 : 64 }}
        >
          <a href="#top" data-testid={MARLEA.navLogo} className="flex items-center">
            <Logo size={30} />
          </a>

          <div className="hidden lg:flex items-center gap-0.5">
            {links.map((l) => (
              <a
                key={l.id}
                href={l.href}
                data-testid={l.id}
                className="px-3 py-2 text-[13px] text-[#A7A7A7] hover:text-white transition-colors rounded-lg hover:bg-white/5"
              >
                {l.label}
              </a>
            ))}
          </div>

          <div className="hidden md:flex">
            <button
              data-testid={MARLEA.navCtaDemo}
              onClick={onScrollDemo}
              className="group inline-flex items-center gap-1.5 rounded-full bg-gradient-neon px-4 py-2 text-[13px] font-semibold text-[#0A0A1A] transition-transform duration-200 hover:scale-[1.04] glow-soft"
            >
              <Sparkles className="h-3.5 w-3.5" />
              Vraag gratis demo aan
            </button>
          </div>

          <button
            data-testid={MARLEA.navMobileToggle}
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden p-2 rounded-lg border border-white/10 text-white"
            aria-label="Menu"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </nav>

        {open && (
          <div className="lg:hidden mt-2 glass-strong rounded-2xl p-3 flex flex-col gap-1">
            {links.map((l) => (
              <a
                key={l.id}
                href={l.href}
                data-testid={`${l.id}-mobile`}
                onClick={() => setOpen(false)}
                className="px-3 py-3 text-sm text-[#A7A7A7] hover:text-white rounded-lg hover:bg-white/5"
              >
                {l.label}
              </a>
            ))}
            <button
              data-testid={`${MARLEA.navCtaDemo}-mobile`}
              onClick={() => {
                setOpen(false);
                onScrollDemo();
              }}
              className="mt-1.5 rounded-full bg-gradient-neon px-5 py-3 text-sm font-semibold text-[#0A0A1A]"
            >
              Vraag gratis demo aan
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default Navbar;
